import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavComponent = _resolveComponent("NavComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_NavComponent),
      _createVNode(_component_v_main, {
        fluid: "",
        class: "primary fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      (_ctx.showFooter)
        ? (_openBlock(), _createBlock(_component_FooterComponent, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_Snackbar),
      _createVNode(_component_CookieConsent)
    ]),
    _: 1
  }))
}